module.exports = __webpack_public_path__ + "static/media/search.0fcb6921.svg";